import React, { useState } from "react";
import { Link } from 'react-router-dom';
import {useTheme, useMediaQuery } from '@mui/material';
import { Container, Grid, Button, Typography, Box, List, Rating , ListItemm, TextField, MenuItem, RadioGroup, FormControlLabel, Radio} from '@mui/material';
import CardMedia from '@mui/material/CardMedia';

import bg from '../assests/images/bg.jpg';
import bg1 from "../assests/images/Z6A2937.jpg"
import { TfiEmail } from "react-icons/tfi";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { SlLocationPin } from "react-icons/sl";
import chef from "../assests/images/chefs-are-brainstorming-e1690389530692.jpg"
import chef2 from "../assests/images/chefAdel1.jpg"
export default function Contact() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [needConsultation, setNeedConsultation] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    timeSlot: '',
  });

  const availableTimeSlots = [
    '10:00 AM - 11:00 AM',
    '12:00 PM - 01:00 PM',
    '02:00 PM - 03:00 PM',
    '04:00 PM - 05:00 PM',
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, needConsultation }),  // Include needConsultation in the form data
      });

      if (response.ok) {
        alert('Email sent successfully');
      } else {
        alert('Failed to send email');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error sending the email');
    }
  };

  return (
    <div>
      <Grid 
         container 
         component="main" 
         
         sx={{
            backgroundImage: `url(${bg1})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            paddingY: '4rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'ceter',
            paddingY: '15%'


          }}

      >

         {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#182427',
          opacity: 0.3,
          zIndex: 1,
        }}
      />

        <Grid
        item
        xs ={12}
        md={12}
        sx={{
          
            zIndex: 2,
        }}

        >
            <Typography component="h2" variant="h2" align="center"  className='sub-heading' style={{color: 'white', fontWeight: '600'}} >
          Get in Touch      
        </Typography>

             </Grid>
             </Grid>

             <Grid
             container
             sx={{

              padding: isSmUp? '2rem 4rem' : "2rem 2rem" 
            }}
             >

              <Grid 
              item
              sm={12}
              md={4}
              sx={{
                display:'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding:3
              }}
              >

              <TfiEmail className='icon'/>
              <Typography component="p" variant="p" my={3} align="center"  className='heading'  >
              Reach out to me directly via email for business inquiries, collaborations, or service requests.
        </Typography>
              <Typography component="h5" variant="h5" align="center"  className='sub-heading-2'  >
              chef.adel.aljaadi@gmail.com     
        </Typography>
              </Grid>

              <Grid 
              item
              sm={12}
              md={4}
              sx={{
                display:'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding:3
              }}
              >

              <LiaPhoneVolumeSolid  className='icon'/>
              <Typography component="p" variant="p" my={3} align="center"  className='heading'  >
              Call or WhatsApp me to discuss your project in detail or schedule a consultation.
        </Typography>
              <Typography component="h5" variant="h5" align="center"  className='sub-heading-2'  >
              +96871701233    
        </Typography>
              </Grid>

              <Grid 
              item
              sm={12}
              md={4}
              sx={{
                display:'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding:3
              }}
              >

              <SlLocationPin   className='icon'/>
              <Typography component="p" variant="p" my={3} align="center"  className='heading'  >
              Currently based in  Oman. I am available for global travel upon request, provided visa sponsorship is available.   
        </Typography>
        <Typography component="h5" variant="h5" align="center"  className='sub-heading-2'  >
         Muscat, Oman  
        </Typography>
              </Grid>

            


             </Grid>

             <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 

      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

<Grid
      container
      sm={12}
      md={12}
              lg={6}
      sx={{
        backgroundColor: 'white',
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" ,
        zIndex: 2, // Ensure it's on top of the overlay
      }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container sm={12} md={12} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
          {/* Name Field */}
          <Grid item sm={12} md={5.5}>
            <Typography component="h5" variant="h5" align="start" className="sub-heading-2">
              Your Name
            </Typography>
            <input className="input" type="text" name="name" value={formData.name} onChange={handleInputChange}  required />
          </Grid>

          {/* Email Field */}
          <Grid item sm={12} md={5.5}>
            <Typography component="h5" variant="h5" align="start" className="sub-heading-2">
              Your Email
            </Typography>
            <input className="input" type="email" name="email" value={formData.email} onChange={handleInputChange} required />
          </Grid>
        </Grid>

        {/* Subject Field */}
        <Grid item sm={12} md={12} sx={{ marginBottom: '1.5rem' }}>
          <Typography component="h5" variant="h5" align="start" className="sub-heading-2">
            Subject
          </Typography>
          <input type="text" name="subject" value={formData.subject} onChange={handleInputChange} className="input" required />
        </Grid>

        {/* Message Field */}
        <Grid item sm={12} md={12}>
          <Typography component="h5" variant="h5" align="start" className="sub-heading-2">
            Message
          </Typography>
          <input className="input" type="text" name="message" value={formData.message} onChange={handleInputChange} required />
        </Grid>

        {/* Radio Button for Consultation */}
        <Grid item sm={12} md={12} sx={{ marginTop: '1.5rem' }}>
          <Typography component="h5" variant="h5" align="start" className="sub-heading-2">
            Need a free consultation?
          </Typography>
          <RadioGroup
              row
              name="consultation"
              value={needConsultation}
              onChange={(e) => setNeedConsultation(e.target.value === 'true')}
            >
              <FormControlLabel 
                value={false} 
                control={
                  <Radio 
                    sx={{
                      color: '#d3752b',
                      '&.Mui-checked': {
                        color: '#d3752b',
                      },
                    }} 
                  />
                } 
                label="No" 
              />
              <FormControlLabel 
                value={true} 
                control={
                  <Radio 
                    sx={{
                      color: '#d3752b',
                      '&.Mui-checked': {
                        color: '#d3752b',
                      },
                    }} 
                  />
                } 
                label="Yes" 
              />
            </RadioGroup>
        </Grid>

        {/* Time Slot Dropdown (Conditionally Rendered) */}
        {/* {needConsultation && (
          <Grid item sm={12} md={12} sx={{ marginBottom: '1.5rem' }}>
            <Typography component="h5" variant="h5" align="start" className="sub-heading">
              Choose a Time Slot
            </Typography>
            <TextField
              select
              fullWidth
              variant="outlined"
              name="timeSlot"
              value={formData.timeSlot}
              onChange={handleInputChange}
              required={needConsultation}
            >
              {availableTimeSlots.map((slot, index) => (
                <MenuItem key={index} value={slot}>
                  {slot}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )} */}

        {/* Submit Button */}
        <Grid item sm={12} md={12} sx={{ textAlign: 'center' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ marginTop: '2rem', backgroundColor: '#d3752b' }}
          >
           Submit qurey
          </Button>
        </Grid>
      </form>
    </Grid>

              <Grid
              container
              my={3}
              sm={12}
              md={12}
              lg={6}
              sx={{
                zIndex: 2,
                displaY: 'flex',
                justifyContent: 'center',
                padding:3
              }}

              > 
              
                <CardMedia
    component="img"  // This tells CardMedia to act like an img element
    alt="Chef Abu Shadi" 
    image={chef2} 
    sx={{ 
      width: { md: 550, sm: '100%' },
      height: 'auto' // Ensure the height adjusts automatically
    }} 
  />
              </Grid>


             </Grid>

      
    </div>
  )
}
